export enum WorkflowType {
    None = 0,
    OrderCancellation = 1,
    CustomPricing = 2,
    InDispute = 3,
    Refund = 4
}